import React from "react";
import { loginUrls } from "js/api/loginApi";

interface GoogleLoginButtonProps {
	deviceId?: string;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ deviceId }) => {
	const handleLoginWithGoogle = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		window.location.href = loginUrls.google(deviceId);
	};

	return (
		<button className="google-login-button" onClick={handleLoginWithGoogle}>
			<div className="google-logo" />
			<div className="login-text">Sign in with Google</div>
		</button>
	);
};

export default GoogleLoginButton;
